import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { useBuilding } from 'app/shared/contexts/building';
import { useContent } from 'app/shared/contexts/content';
import { useSdkHostInfo } from 'app/shared/hooks/use-sdk-host-info';
import { useTrackWebClick } from 'app/shared/hooks/use-track-web-click';
import { HOST_PLATFORMS } from 'app/shared/consts';

export const DESCRIPTION_LINK_ELEMENT_NAME = 'DESCRIPTION_LINK';

export type TrackDescriptionLinkClick = (linkUrl: string) => void;

export const useTrackDescriptionLinkClick = (): TrackDescriptionLinkClick => {
  const location = useLocation();
  const { building } = useBuilding();
  const { content } = useContent();
  const { hostPlatform } = useSdkHostInfo();
  const trackWebClick = useTrackWebClick();

  return useCallback(
    (linkUrl: string) => {
      if (!linkUrl) return;
      trackWebClick({
        route: location.pathname,
        element_name: DESCRIPTION_LINK_ELEMENT_NAME,
        click_type: 'navigation',
        destination_route: linkUrl,
        additional_properties: {
          content_uuid: content?.uuid ?? '',
          link_url: linkUrl,
          building_uuid: building?.uuid ?? '',
          host_platform: hostPlatform ?? HOST_PLATFORMS.MOBILE,
        },
      });
    },
    [trackWebClick, location.pathname, content?.uuid, building?.uuid, hostPlatform],
  );
};
